<template>
  <div id="app">

    <!-- Top strip -->
    <div class="top-strip">
      ສາທາລະນະລັດ ປະຊາທິປະໄຕ ປະຊາຊົນລາວ &nbsp;|&nbsp; Lao People's Democratic Republic
    </div>

    <!-- Main Header -->
    <div class="main-header">
      <b-container fluid class="px-4">
        <b-row align-v="center" class="py-3">
          <b-col cols="auto">
            <b-img :src="require('./assets/laos_logo.png')" class="header-logo" alt="Lao PDR Logo"></b-img>
          </b-col>
          <b-col>
            <p class="org-name-lao">ກົມກົງສຸນ ກະຊວງການຕ່າງປະເທດ</p>
            <p class="org-name-en">Department of Consular Affairs, Ministry of Foreign Affairs</p>
            <p class="org-name-sub">ສາທາລະນະລັດ ປະຊາທິປະໄຕ ປະຊາຊົນລາວ</p>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <!-- Navbar -->
    <b-navbar toggleable="lg" class="main-nav">
      <b-navbar-toggle target="nav-collapse" class="nav-toggler">
        <b-icon icon="list" font-scale="1.5" style="color:#fff;"></b-icon>
      </b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item class="nav-menu-item" to="/">{{ $t('HomePage.Home') }}</b-nav-item>
          <b-nav-item class="nav-menu-item" to="/info">{{ $t('HomePage.info') }}</b-nav-item>
          <b-nav-item class="nav-menu-item" to="/law">{{ $t('HomePage.law') }}</b-nav-item>
          <b-nav-item class="nav-menu-item" to="/document">{{ $t('HomePage.document') }}</b-nav-item>
          <b-nav-item class="nav-menu-item" to="/about">{{ $t('HomePage.aboutus') }}</b-nav-item>
          <b-nav-item class="nav-menu-item" to="/contract">{{ $t('HomePage.contract') }}</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <!-- Page Content -->
    <div class="page-wrapper">
      <router-view />
    </div>

    <!-- Footer -->
    <footer class="main-footer">
      <b-container fluid class="px-5">
        <b-row class="pt-4">
          <b-col md="4" class="mb-4">
            <div class="d-flex align-items-center mb-3">
              <b-img :src="require('./assets/laos_logo.png')" height="64" class="mr-3" alt="Logo"></b-img>
              <div>
                <p class="footer-org-name">ກົມກົງສຸນ</p>
                <p class="footer-org-en">Department of Consular Affairs</p>
              </div>
            </div>
            <p class="footer-desc">
              ກົມກົງສຸນ ກະຊວງການຕ່າງປະເທດ ແຫ່ງ ສາທາລະນະລັດ ປະຊາທິປະໄຕ ປະຊາຊົນລາວ
            </p>
          </b-col>

          <b-col md="4" class="mb-4">
            <p class="footer-heading">ລິ້ງທີ່ກ່ຽວຂ້ອງ</p>
            <div class="footer-link-item">
              <b-icon icon="chevron-right" class="mr-1"></b-icon>
              <a href="http://www.mofa.gov.la/index.php/lo/" target="_blank" class="footer-link">ກະຊວງການຕ່າງປະເທດ</a>
            </div>
            <div class="footer-link-item">
              <b-icon icon="chevron-right" class="mr-1"></b-icon>
              <a href="https://immigration.gov.la/" target="_blank" class="footer-link">ກົມຕໍາຫຼວດກວດຄົນເຂົ້າ-ອອກເມືອງ</a>
            </div>
            <div class="footer-link-item">
              <b-icon icon="chevron-right" class="mr-1"></b-icon>
              <a href="https://laoevisa.gov.la/index" target="_blank" class="footer-link">Lao eVISA</a>
            </div>
          </b-col>

          <b-col md="4" class="mb-4">
            <p class="footer-heading">ຕິດຕໍ່ພວກເຮົາ</p>
            <div class="footer-contact-item">
              <b-icon icon="geo-alt-fill" class="mr-2 footer-icon-gold"></b-icon>
              23 ຖະໜົນສິງຫາ, ບ້ານໂພນສະຫວ່າງ, ເຂດໄຊເສດຖາ, ນະຄອນຫຼວງວຽງຈັນ
            </div>
            <div class="footer-contact-item">
              <b-icon icon="telephone-fill" class="mr-2 footer-icon-gold"></b-icon>
              021 254176
            </div>
            <div class="footer-contact-item">
              <b-icon icon="envelope-fill" class="mr-2 footer-icon-gold"></b-icon>
              consular@mofa.gov.la
            </div>
            <div class="footer-contact-item">
              <b-icon icon="globe" class="mr-2 footer-icon-gold"></b-icon>
              www.consularlao.gov.la
            </div>
          </b-col>
        </b-row>

        <hr class="footer-divider">
        <p class="footer-copy text-center mb-0 pb-3">
          Copyright &copy; 2022, Ministry of Foreign Affairs of LAO PDR. All Rights Reserved. &nbsp;|&nbsp; Developed by LAOSOFT
        </p>
      </b-container>
    </footer>

    <!-- Announcement Modal -->
    <b-modal
      v-for="item in items"
      :key="item.id"
      id="modal-xl"
      visible
      size="xl"
      hide-footer
      title="ແຈ້ງການ"
    >
      <b-img :src="item.link" fluid alt="Responsive image"></b-img>
    </b-modal>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "App",
  components: {},
  data() {
    return { items: [] };
  },
  created() {
    axios
      .get(this.$store.getters.getBaseUrl + "/noties/1/1", {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer anUrbLQdEVK7V/w3Mjkp28ZDJXgDH7SpKeqtKBjkqMnNJT4OQ?ukI8w7M5/HmxsONU78KEg4p=!5r0WOf=5/zBa9h/PTI42lb5JEhR855=LTAt!!AeJBFkmFtrpOwS7KhMuk!=B=8Rn=aqz6U59ZoPATYEKFkaZ-C/4ZRUXjUfb4DA0-69KsueEHkI/RW8mD2lLudpbe5JZpti=uQmQe5Nq2G6pP9//DX9hGm3yFpVMInuh-O50nbYdMej1miJTs",
          "Accept-Encoding": "identity",
        },
      })
      .then((r) => {
        this.items = r.data;
      });
  },
};
</script>

<style>
/* ── Base ─────────────────────────────────────────────────── */
#app {
  font-family: "Noto Sans Lao Regular", "Phetsarath OT", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #f4f6fb;
}

/* ── Top strip ────────────────────────────────────────────── */
.top-strip {
  background: #ce1126;
  color: #fff;
  font-size: 12px;
  padding: 5px 20px;
  text-align: center;
  letter-spacing: 0.4px;
}

/* ── Header ───────────────────────────────────────────────── */
.main-header {
  background: linear-gradient(135deg, #003087 0%, #1b3a6b 100%);
  border-bottom: 4px solid #d4af37;
}
.header-logo {
  height: 82px;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.35));
}
.org-name-lao {
  font-size: 1.55rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 2px;
  line-height: 1.2;
  text-shadow: 0 1px 3px rgba(0,0,0,0.3);
}
.org-name-en {
  font-size: 0.95rem;
  color: #9fc3e8;
  margin: 0 0 2px;
}
.org-name-sub {
  font-size: 0.8rem;
  color: #d4af37;
  margin: 0;
  letter-spacing: 0.4px;
}

/* ── Navbar ───────────────────────────────────────────────── */
.main-nav {
  background: #002868 !important;
  padding: 0 24px;
  border-bottom: 3px solid #d4af37;
}
.nav-toggler {
  border: 1px solid rgba(255,255,255,0.3) !important;
  padding: 6px 10px;
  border-radius: 4px;
}
.nav-menu-item .nav-link {
  color: #dce8f5 !important;
  font-weight: 600;
  font-size: 0.88rem;
  padding: 15px 18px !important;
  letter-spacing: 0.3px;
  transition: color 0.2s, background 0.2s;
  border-bottom: 3px solid transparent;
}
.nav-menu-item .nav-link:hover {
  color: #d4af37 !important;
  background: rgba(212, 175, 55, 0.08);
  border-bottom-color: #d4af37;
}
.nav-menu-item .nav-link.router-link-exact-active,
.nav-menu-item .nav-link.router-link-active {
  color: #d4af37 !important;
  border-bottom: 3px solid #d4af37;
  background: rgba(212, 175, 55, 0.08);
}

/* ── Page Content ─────────────────────────────────────────── */
.page-wrapper {
  min-height: 520px;
  background: #f4f6fb;
}

/* ── Footer ───────────────────────────────────────────────── */
.main-footer {
  background: #0d1b3e;
  color: #8ba3be;
  margin-top: 0;
}
.footer-org-name {
  font-size: 1.1rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 2px;
}
.footer-org-en {
  font-size: 0.8rem;
  color: #8ba3be;
  margin: 0;
}
.footer-desc {
  font-size: 0.85rem;
  color: #7a92aa;
  line-height: 1.6;
  margin: 0;
}
.footer-heading {
  color: #d4af37;
  font-weight: 700;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-bottom: 14px;
  padding-bottom: 8px;
  border-bottom: 1px solid #1e2f50;
}
.footer-link-item {
  color: #8ba3be;
  font-size: 0.88rem;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}
.footer-link {
  color: #8ba3be;
  text-decoration: none;
  transition: color 0.2s;
}
.footer-link:hover {
  color: #d4af37;
  text-decoration: none;
}
.footer-contact-item {
  font-size: 0.87rem;
  color: #8ba3be;
  margin-bottom: 9px;
  display: flex;
  align-items: flex-start;
}
.footer-icon-gold {
  color: #d4af37;
  flex-shrink: 0;
  margin-top: 2px;
}
.footer-divider {
  border-color: #1e2f50;
  margin: 10px 0 0;
}
.footer-copy {
  font-size: 0.78rem;
  color: #4d6278;
}
</style>
